<template>
  <div>
    <b-container class="mt-5 mb-5">
      <b-button
        variant="outline-primary"
        @click="deleteLocation()"
        class="float-right"
      >
        Verwijder locatie
      </b-button>
      <h1 class="fs-4 font-weight-bold mb-4">Locatie wijzigen</h1>

      <ValidationObserver ref="form" slim>
        <b-card class="mb-3">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">Naam locatie</label>
              <b-form-input v-model="form.name" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">Plaats</label>
              <b-form-input v-model="form.place" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <div class="mb-3">
            <label>Omschrijving</label>
            <VueTrix v-model="form.description" />
          </div>

          <ValidationProvider rules="email" v-slot="{ errors }">
            <div class="mb-3">
              <label>Contact e-mail</label>
              <p class="text-muted mb-2">
                Wordt weergegeven op de evenementen pagina van de desbetreffende
                locatie.
              </p>
              <b-form-input v-model="form.email" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <b-row>
            <b-col md="6">
              <div class="mb-3">
                <label>Header</label>
                <p class="text-muted">
                  Optimaal formaat: 1920x1080 / 4:3 ratio (max. 5MB)
                </p>
                <DropFile
                  v-model="form.header_image"
                  accept="image/png,image/jpeg"
                />
              </div>
            </b-col>
            <b-col md="6">
              <div class="mb-3">
                <label>Logo</label>
                <p class="text-muted">
                  Optimaal formaat: 1024x1024 / 1:1 ratio (max. 5MB)
                </p>
                <DropFile
                  v-model="form.header_logo"
                  accept="image/png,image/jpeg"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>

      <b-card class="mb-3" no-body>
        <b-card-header>
          <h3 class="fs-5 mb-0">Gekoppelde evenementen</h3>
        </b-card-header>
        <b-card-body>
          <template v-if="events.length">
            <template v-for="(event, key) in events">
              <EventItem :key="key" :event="event" :showDuplicate="false" />
            </template>
          </template>
          <template v-else>
            Er zijn geen evenementen gekoppeld aan deze locatie.
          </template>
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="mt-4"
            @change="onPageChange"
          />
        </b-card-body>
      </b-card>

      <div class="clearfix">
        <b-button @click="saveLocation" variant="primary" class="float-right">
          Opslaan
          <font-awesome-icon icon="fa-solid fa-chevron-right" />
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useShopStore } from "@/stores/shop";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueTrix from "vue-trix";

import DropFile from "@/components/DropFile.vue";
import EventItem from "@/components/event/EventItem";

export default {
  metaInfo: {
    title: "Locatie wijzigen",
  },
  components: {
    DropFile,
    EventItem,
    VueTrix,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        description: "",
        place: "",
        header_image: "",
        header_logo: "",
      },
      events: [],
      currentPage: 1,
      perPage: 3,
      totalRows: 0,
    };
  },
  computed: {},
  methods: {
    ...mapActions(useShopStore, ["setLoading"]),
    deleteLocation: function () {
      if (confirm("Weet je zeker dat je deze locatie wilt verwijderen?")) {
        this.$axios
          .delete("https://api.tixgo.nl/locations/" + this.$route.params.id)
          .then((response) => {
            response;
            this.$router.push("/manage/organisation/locations");
          });
      }
    },
    getEvents(page = 1) {
      this.setLoading(true);

      this.$axios
        .get(
          `https://api.tixgo.nl/events?archived=all&page=${page}&per_page=${this.perPage}&location=${this.$route.params.id}`,
        )
        .then((response) => {
          this.events = response.data.data;
          this.totalRows = response.data.total;
          this.currentPage = response.data.current_page;

          this.setLoading(false);
        })
        .catch((reason) => {
          console.log(reason);
          this.setLoading(false);
        });
    },
    getLocation: function () {
      this.setLoading(true);
      this.$axios
        .get("https://api.tixgo.nl/locations/" + this.$route.params.id)
        .then((response) => {
          this.form = response.data;
          this.setLoading(false);
        });
    },
    async saveLocation() {
      let check = await this.$refs["form"].validate();

      if (!check) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      let id = this.$route.params.id;
      this.$axios
        .put("https://api.tixgo.nl/locations/" + id, this.form)
        .then((response) => {
          response;
          this.$router.push("/manage/organisation/locations");
        });
    },
    onPageChange(page) {
      this.getEvents(page);
    },
  },
  created() {
    this.getLocation();
    this.getEvents(1);
  },
};
</script>
